import React from 'react';
import cn from 'classnames';

import Icon from 'components/acommon/Icon';

import styles from './Counter.module.sass';

export type CounterProps = {
  className?: string;
  value: number;
  onDecrement: () => void;
  onIncrement: () => void;
  disabled?: boolean;
};

const Counter = ({
  className,
  value,
  onIncrement,
  onDecrement,
  disabled,
}: CounterProps) => {
  return (
    <div className={cn(className, styles.counter)}>
      <button
        className={cn(styles.button, {[styles.disabled]: disabled || value === 0})}
        onClick={event => {
          event.stopPropagation();
          event.preventDefault();
          !disabled && onDecrement();
        }}
        type="button"
      >
        <Icon name="minus" size="24" />
      </button>
      <div
        className={cn(
          styles.number,
          {[styles.disabled]: disabled},
          'counter-content-value',
        )}
      >
        {value}
      </div>
      <button
        className={cn(styles.button, {[styles.disabled]: disabled})}
        onClick={event => {
          event.stopPropagation();
          event.preventDefault();
          !disabled && onIncrement();
        }}
        type="button"
      >
        <Icon name="plus" size="24" />
      </button>
    </div>
  );
};

export {Counter};
